import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import Messages from '../constants/messages'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired
}

const styles = theme => ({
  root: {
    minWidth: 320,
    maxWidth: 800,
    margin: 'auto'
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 60
  },
  footer: {
    padding: 15,
    position: 'fixed',
    fontSize: 14,
    bottom: 0
  },
  copyright: {
    display: 'inline-block',
    width: '100%',
    textAlign: 'left'
  },
  nordstromLogo: {
    padding: 10,
    width: '60%',
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline'
  }
})

export class NotFound extends Component {

  render() {
    const { changePage, classes } = this.props
    return (
      <section>
        <section className={classes.root}>
          <div className={classes.heading}>
            <img
              data-test-id="nordstrom-logo"
              src="https://s3-us-west-2.amazonaws.com/nauth-prod/Design+Assets/nord_logo/nord_logo_black%402x.png"
              className={classes.nordstromLogo}
              alt="nordstrom logo" />
              <Typography type="title">{Messages['uiComponents']['APPLICATION_NAME']}</Typography>
          </div>
          <Typography type="display1" align={'center'} gutterBottom>
            {Messages['uiComponents']['NOT_FOUND_1']}
          </Typography>
          <Typography type="subheading" align={'center'} gutterBottom>
            {Messages['uiComponents']['NOT_FOUND_2']}
            <span onClick={() => changePage()} className={classes.link} data-test-id="homepage">Homepage</span>
            {Messages['uiComponents']['NOT_FOUND_3']}
          </Typography>
        </section>
        <div className={classes.footer}>
          <span className={classes.copyright} data-test-id="nordstrom-copy">&copy; {`${(new Date()).getFullYear()} Nordstrom, Inc.`}</span>
        </div>
      </section>
    )
  }
}

NotFound.propTypes = PROP_TYPES

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: () => push('/users')
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(NotFound)
